"use strict";

var _regeneratorRuntime = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");
var _asyncToGenerator = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _validation = require("./validation");
describe('hebrewOnly validation', function () {
  it('valid single word', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _validation.hebrewOnly.isValid('שם');
          case 2:
            result = _context.sent;
            expect(result).toEqual(true);
          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
  it('valid two words', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _validation.hebrewOnly.isValid('שם משפחה');
          case 2:
            result = _context2.sent;
            expect(result).toEqual(true);
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
  it('invalid single word', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _validation.hebrewOnly.isValid('name');
          case 2:
            result = _context3.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })));
  it('invalid digits', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var result;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _validation.hebrewOnly.isValid('999');
          case 2:
            result = _context4.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })));
  it('invalid - empty', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var result;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _validation.hebrewOnly.isValid('');
          case 2:
            result = _context5.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  })));
});
describe('validPhone validation', function () {
  it('home phone should be valid', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var result;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _validation.validPhone.isValid('08-9123344');
          case 2:
            result = _context6.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  })));
  it('mobile 1 - valid', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var result;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _validation.validPhone.isValid('050-1234567');
          case 2:
            result = _context7.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })));
  it('mobile 2 - valid', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var result;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _validation.validPhone.isValid('0501234567');
          case 2:
            result = _context8.sent;
            expect(result).toEqual(true);
          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  })));
  it('invalid phone 1', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    var result;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _validation.validPhone.isValid('1234567890');
          case 2:
            result = _context9.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  })));
  it('invalid phone 2', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var result;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _validation.validPhone.isValid('08-123456');
          case 2:
            result = _context10.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  })));
  it('invalid not a phone', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var result;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return _validation.validPhone.isValid('name');
          case 2:
            result = _context11.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  })));
  it('invalid - empty', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var result;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _validation.validPhone.isValid('');
          case 2:
            result = _context12.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  })));
});
describe('validIsraeliId validation', function () {
  it('unvalid short id', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var result;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return _validation.validIsraeliId.isValid('0000');
          case 2:
            result = _context13.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  })));
  it('valid long id', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    var result;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return _validation.validIsraeliId.isValid('123456789');
          case 2:
            result = _context14.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  })));
  it('invalid too short id', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
    var result;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return _validation.validIsraeliId.isValid('1234');
          case 2:
            result = _context15.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  })));
  it('invalid too long id', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    var result;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return _validation.validIsraeliId.isValid('1234567890');
          case 2:
            result = _context16.sent;
            expect(result).toEqual(false);
          case 4:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  })));
  it('invalid ids', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _validation.invalidIdArray.forEach( /*#__PURE__*/function () {
              var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(id) {
                var result;
                return _regeneratorRuntime.wrap(function _callee17$(_context17) {
                  while (1) {
                    switch (_context17.prev = _context17.next) {
                      case 0:
                        _context17.next = 2;
                        return _validation.validIsraeliId.isValid(id);
                      case 2:
                        result = _context17.sent;
                        expect(result).toEqual(false);
                      case 4:
                      case "end":
                        return _context17.stop();
                    }
                  }
                }, _callee17);
              }));
              return function (_x) {
                return _ref18.apply(this, arguments);
              };
            }());
          case 1:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  })));
  it('should be valid', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
    var result;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return _validation.validIsraeliId.isValid('208516435');
          case 2:
            result = _context19.sent;
            expect(result).toEqual(true);
          case 4:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  })));
  it('should be valid 2', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
    var result;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return _validation.validIsraeliId.isValid('221993561');
          case 2:
            result = _context20.sent;
            expect(result).toEqual(true);
          case 4:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  })));
});
describe('crcValidIsraeliId validation', function () {
  it('valid long id', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
    var result;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return _validation.validIsraeliId.isValid('123456782');
          case 2:
            result = _context21.sent;
            expect(result).toEqual(true);
          case 4:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  })));

  // TODO: unmark after CRC is fixec
  // it('invalid long id', async () => {
  //   const result = await validIsraeliId.isValid('123456785');
  //   expect(result).toEqual(false);
  // });
  //
  // it('invalid long id', async () => {
  //   const result = await validIsraeliId.isValid('12345678');
  //   expect(result).toEqual(false);
  // });
});